import { createSlice } from '@reduxjs/toolkit';
import { faqAction } from '../actions';
import { faqReducer as extraReducers } from '../reducers';
import { IFaqState } from '../../interfaces';

const initialState: IFaqState = {
  status: 'inactive',
  faqs: [],
  error: '',
};

export const faqSlice = createSlice({
  name: 'faq',
  initialState,
  // Non-async reducers
  reducers: {
    resetFaq: () => {
      return initialState;
    },
  },
  // Async reducers
  extraReducers,
});

// Action creators are generated for each case reducer function
export const faqSliceActions = { ...faqSlice.actions, ...faqAction };

export default faqSlice.reducer;
